import styled from "styled-components";

export const Container = styled.main``;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    max-height: 500px;
    overflow-y: auto;

    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Title = styled.p`
    font-size: 32px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.gray.gray_800};
`;

export const ContentInfor = styled.div`
    display: flex;
    align-items: start;
    flex-direction: column;
    gap: 4px;
`;

export const Infor = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
    }
    `;

export const Confirme = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    color: ${(props) => props.theme.colors.success};
    font-size: 14px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    
`;

export const SectionButton = styled.button<{ isPaid: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    background-color: transparent;

    cursor: pointer;
    opacity: ${(props) => props.isPaid ? 0.6 : 1};

    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
        border-radius: 4px;
    }

    svg{
        color: ${(props) => props.theme.colors.gray.gray_500};
    }
`;

export const TitleButton = styled.p`
    font-size: 20px;
`;

export const Status = styled.div<{ isPay: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border: 1px solid ${(props) => (props.isPay ? props.theme.colors.success : props.theme.colors.warning)};
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    color: ${(props) => (props.isPay ? props.theme.colors.success : props.theme.colors.warning)};
    border-radius: 30px;
    padding: 0px 4px;
    
    svg{
        color: ${(props) => (props.isPay ? props.theme.colors.success : props.theme.colors.warning)};
    }
`;